import httpClient from "../utils/httpClient";

export const GetParameters = async (payload) => {
    const response = await httpClient.post('Parameter/get-parameters', payload);
    return response.data;
};